import type { JSX } from 'react';

import { usePetitionDetailsPageData, usePetitionDetailsPageUserData } from 'src/app/pages/petitionDetails/pageContext';

import { RespondContainerSunrise } from '../RespondSunrise';

import { SideClosedContainer } from './SideClosed';
import { SideSignedContainer } from './SideSigned';
import { SideUnsignedContainer } from './SideUnsigned';
import { SideVictoryContainer } from './SideVictory';

function SideContainerInner(): JSX.Element {
	const {
		data: {
			petition: { status },
		},
	} = usePetitionDetailsPageData();
	const {
		data: { decisionMaker, signed },
	} = usePetitionDetailsPageUserData();

	if (decisionMaker) {
		return <RespondContainerSunrise />;
	}
	if (status === 'CLOSED') {
		return <SideClosedContainer />;
	}
	if (status === 'VICTORY') {
		return <SideVictoryContainer />;
	}
	if (signed) {
		return <SideSignedContainer />;
	}
	return <SideUnsignedContainer />;
}

type Props = {
	containerRef?: React.RefObject<HTMLDivElement>;
};

export function SideContainer({ containerRef }: Props): JSX.Element {
	return (
		<div ref={containerRef} className="rounded-large p-8 elevation-floating">
			<SideContainerInner />
		</div>
	);
}
